import { dataguard } from '@/renderer/utils/vike/dataguard';
import { data as serverData } from './dataFetcher';

export async function data(pageContext: Vike.PageContext) {
  const [userData, pageData] = await Promise.all([
    dataguard(pageContext, { ignoreLoggedOut: true, fetchOn: 'client' }),
    serverData(pageContext),
  ]);

  return { ...userData, ...pageData };
}
